import { css } from '@emotion/react';

import { rem } from '../utilities/style';
import iconDotPattern from '../images/dot-pattern.svg';

// eslint-disable-next-line import/prefer-default-export
export const dotPatternStyles = css`
  background-image: url(${iconDotPattern});
  background-size: ${rem(90)} ${rem(56)};
  background-repeat: round;
`;
